var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleBigquery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9488 53.2504L1.95027 32.4675C1.48896 31.6685 1.24609 30.7621 1.24609 29.8395C1.24609 28.9169 1.48896 28.0105 1.95027 27.2115L13.9488 6.42904C14.4102 5.6299 15.0738 4.9663 15.873 4.50494C16.6721 4.04358 17.5787 3.80072 18.5014 3.80078H42.4986C43.4212 3.8008 44.3277 4.0437 45.1267 4.50505C45.9258 4.96641 46.5893 5.62997 47.0507 6.42904L59.0492 27.2115C59.5107 28.0105 59.7536 28.917 59.7536 29.8397C59.7536 30.7624 59.5107 31.6689 59.0492 32.468L47.0507 53.2504C46.5893 54.0494 45.9257 54.7128 45.1267 55.1741C44.3276 55.6354 43.4212 55.8782 42.4986 55.8782H18.5014C17.5787 55.8783 16.6721 55.6355 15.873 55.1741C15.0738 54.7127 14.4102 54.0491 13.9488 53.2499V53.2504Z",
    fill: "url(#paint0_linear_3590_31674)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M55.7453 40.1155L38.0999 22.4691L30.5008 20.4355L23.6751 22.9724L21.0391 29.8401L23.1586 37.4868L41.8708 56.199L45.8416 56.0226L55.7453 40.1155Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5006 19.2373C24.6453 19.2373 19.8984 23.9842 19.8984 29.8399C19.8984 35.6952 24.6453 40.4421 30.5006 40.4421C36.3559 40.4421 41.1023 35.6952 41.1023 29.8399C41.1023 23.9842 36.3554 19.2373 30.5006 19.2373ZM30.5006 37.8842C26.0577 37.8842 22.4558 34.2824 22.4558 29.8395C22.4558 25.3966 26.0577 21.7952 30.5006 21.7952C34.9435 21.7952 38.5453 25.397 38.5453 29.8399C38.5453 34.2828 34.9435 37.8847 30.5006 37.8847",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4688 29.4305V32.7261C25.9564 33.5633 26.6443 34.2661 27.4708 34.7716V29.4305H25.4688ZM29.4386 26.6523V35.5249C29.7791 35.5875 30.1274 35.6254 30.4853 35.6254C30.8117 35.6254 31.1298 35.5912 31.442 35.5391V26.6523H29.4386ZM33.5939 30.8V34.7135C34.4336 34.1796 35.123 33.4402 35.5969 32.5652V30.8004L33.5939 30.8ZM38.1305 36.3705L37.0322 37.4698C36.9391 37.563 36.8869 37.6894 36.8869 37.8211C36.8869 37.9528 36.9391 38.0791 37.0322 38.1723L41.1985 42.3373C41.2918 42.4304 41.4181 42.4826 41.5498 42.4826C41.6815 42.4826 41.8078 42.4304 41.9011 42.3373L42.9994 41.2394C43.0919 41.1459 43.1437 41.0198 43.1437 40.8883C43.1437 40.7569 43.0919 40.6308 42.9994 40.5373L38.8326 36.3705C38.7393 36.2778 38.6131 36.2258 38.4816 36.2258C38.3501 36.2258 38.2239 36.2778 38.1305 36.3705Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3590_31674",
    x1: 30.5,
    y1: 3.80124,
    x2: 30.5,
    y2: 55.7973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4387FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4683EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBigquery);
export default __webpack_public_path__ + "static/media/google-bigquery.338b30bf4a5fe5575964aefa7c480044.svg";
export { ForwardRef as ReactComponent };